<div class="content-wrapper-inner">
  @if (loading()) {
    <div class="spinner spinner-wrapper">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
  } @else if (errorType()) {
    <div class="py-20">
      <div class="d-flex align-items-center flex-column">
        <h2 class="mb-20">{{ errorTitle() }}</h2>
        <p class="alert alert-danger mb-20">{{ errorMessage() }}</p>

        @if (errorType() === 'unknown') {
          <button class="btn btn-primary" type="button" (click)="fetchSharedTests()">Retry</button>
        }
      </div>
    </div>
  } @else {
    <div class="mb-20">
      <app-shared-tests-table [sharedTestsResultsInfo]="sharedTestsResultsInfo()"></app-shared-tests-table>
    </div>
  }
</div>
